<template>
  <v-autocomplete
    v-bind="$attrs"
    v-model="input"
    :items="items"
    :multiple="multiple"
  >
    <template v-slot:prepend-item v-if="multiple">
      <v-list-tile @click="toggleAllSelected" :color="isAllSelected() ? 'primary' : ''">
        <v-list-tile-action>
          <v-checkbox
            color="primary"
            :value="isAllSelected()"
            :indeterminate="isAtLeastOneSelectedAndNotAll()"
          ></v-checkbox>
        </v-list-tile-action>

        <v-list-tile-content>
          <v-list-tile-title>Select All</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-divider class="my-1"></v-divider>
    </template>
  </v-autocomplete>
</template>

<script>
export default {
  name: 'Autocomplete',
  props: {
    items: {
      type: Array,
      required: true,
      default: () => []
    },
    value: {
      type: [Array, String, Number],
      default: () => []
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    input: {
      get () {
        return this.value
      },
      set (newVal) {
        this.$emit('input', newVal)
      }
    }
  },
  methods: {
    toggleAllSelected () {
      if (this.input.length) {
        this.input = []
      } else {
        if (this.$attrs['item-value']) {
          this.input = this.items.map(item => item[this.$attrs['item-value']])
        } else {
          this.input = this.items
        }
      }
    },
    isAllSelected () {
      return (this.input && this.input.length) === this.items.length
    },
    isAtLeastOneSelectedAndNotAll () {
      return (this.input && this.input.length) > 0 && !this.isAllSelected()
    },
    clear () {
      this.input = []
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/forms/Autocomplete.vue